"use client";

import { Core } from "@faire/design-tokens";
import styled, { css } from "styled-components";

import {
  HIGH_VIS_FILTER,
  highVisSlateComponent,
} from "../utils/highVisSlateComponent";

export const OUTER_DIAMETER_LARGE = 48;
export const INNER_DIAMETER_LARGE = 40;

export const OUTER_DIAMETER_SMALL = 24;
export const INNER_DIAMETER_SMALL = 20;

// Not in Figma, but discussed with Nick Howland
const DEFAULT_COLOR = Core.surface.subdued;

export const VisuallyHiddenRadioInput = styled.input`
  block-size: 1px;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(0 0 99.9% 99.9%);
  inline-size: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

export const StyledLabel = styled.label<{
  $available: boolean;
  $checked: boolean;
  $disabled: boolean;
  $outerSize: number;
}>`
  align-items: center;
  block-size: ${({ $outerSize }) => $outerSize}px;
  // Border when checked
  border: 1px solid
    ${({ $checked }) => ($checked ? Core.border.enabled : "transparent")};
  border-radius: 50%;
  box-sizing: border-box;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  display: flex;
  inline-size: ${({ $outerSize }) => $outerSize}px;
  justify-content: center;

  // Border styling when not disabled
  ${({ $disabled }) => {
    return $disabled
      ? ""
      : css`
          &:hover {
            border: 1px solid ${Core.border.subdued};
          }

          &:active {
            border: 1px solid ${Core.border.enabled};
          }
        `;
  }};

  // Diagonal slash when not available
  ${({ $available }) => {
    return $available
      ? ""
      : css`
          &::after {
            background-color: ${Core.border.default};
            content: "";
            block-size: 4px;
            border: 1px solid ${Core.surface.inverse};
            display: block;
            inline-size: 52px;
            position: absolute;
            transform: rotate(-45deg);
          }
        `;
  }};
`;

export const SwatchWrapper = styled.div`
  // Outline the label when it's sibling input has focus-visible
  ${VisuallyHiddenRadioInput}:focus-visible + ${StyledLabel} {
    border: 1px solid ${Core.border.subdued};
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: 3px;
  }
  ${highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT)}
`;

export const Image = styled.img<{ $innerSize: number }>`
  block-size: ${({ $innerSize }) => $innerSize}px;
  border-radius: 50%;
  inline-size: ${({ $innerSize }) => $innerSize}px;
`;

export const Circle = styled.div<{ $innerSize: number }>`
  background-color: ${({ color }) => color || DEFAULT_COLOR};
  block-size: ${({ $innerSize }) => $innerSize}px;
  border-radius: 50%;
  inline-size: ${({ $innerSize }) => $innerSize}px;
`;
